// extracted by mini-css-extract-plugin
export var messageSideLeft = "_sz-1";
export var stateContainer = "_sz-0";